import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../../../redux/modals/modalReducer";
import {
  Segment,
  Button,
  Table,
  Label,
  Icon,
  Checkbox,
} from "semantic-ui-react";

const CorrectiveDetail = ({ data }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Segment.Group>
        <Segment color="blue">
          <Label as="a" color="blue" ribbon>
            Actions (correctives et/ou préventives)
          </Label>
          <Button
            primary
            icon
            labelPosition="left"
            onClick={() => dispatch(openModal({ modalType: "CorrectiveForm" }))}
          >
            <Icon name="add" />
            Actions (correctives et/ou préventives)
          </Button>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  Actions (correctives et/ou préventives)
                </Table.HeaderCell>
                <Table.HeaderCell>Responsable de traitement</Table.HeaderCell>
                <Table.HeaderCell>Responsable de suivi</Table.HeaderCell>
                <Table.HeaderCell>Date au plus tard prévue</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {data &&
                data.listConformiteCorrectives.items &&
                data.listConformiteCorrectives.items.map(
                  ({
                    description,
                    userSuivi,
                    userTraitement,
                    id,
                    datePrevu,
                  }) => (
                    <Table.Row key={id}>
                      <Table.Cell collapsing>
                        <Checkbox slider />
                      </Table.Cell>
                      <Table.Cell> {description}</Table.Cell>
                      <Table.Cell> {userTraitement}</Table.Cell>
                      <Table.Cell> {userSuivi}</Table.Cell>
                      <Table.Cell> {datePrevu}</Table.Cell>
                      <Table.Cell>
                        <Button
                          className="ui basic button"
                          onClick={() =>
                            dispatch(
                              openModal({ modalType: "CorrectiveFormEdit" })
                            )
                          }
                        >
                          <i className="green icon edit"> </i>
                        </Button>
                      </Table.Cell>
                      <Table.Cell>
                        <Button className="ui basic button">
                          <i className="red icon trash"></i>
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  )
                )}
            </Table.Body>
          </Table>
        </Segment>
      </Segment.Group>
    </>
  );
};

export default CorrectiveDetail;
